<template>
  <v-autocomplete :label="label ? label : ''" hide-details :outlined="outlined" :items="items" v-model="defaultSelected"
    dense elevation="0" color="#00000000" class="pa-0 ma-0 academy-select"
    :menu-props="{ offsetY: true, maxHeight: '400px' }">
    <template v-slot:item="{ item }">
      <v-list-item @click="selectAcademy(item.value)" class="px-3 py-3 item_selectable"
        style="border-top: 1px solid #eee">
        <v-list-item-avatar color="pa-0">
          <ImageDisplay v-if="item.image" :src="item.image" alt="avatar" />
          <v-icon v-else>mdi-karate</v-icon>
        </v-list-item-avatar>
        <v-list-item-content class="pa-0">
          <v-list-item-title class="pa-0 font-roboto body-1">
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import Api from "@/services/Api";
import { Environment } from "@/services/Environment";

export default {
  data() {
    return {
      selectedItem: null,
      items: [],
      defaultSelected: null,
      defaultAcademy: null,
      defaultManagedAcademy: null,
      defaultAcademyImage: null,
    };
  },
  props: ["outlined", "forceSelect", "label"],
  created() {
    //console.log('Loaded academy: ', this.$store.state.selectedAcademy);
    this.getAdminAcademies();
    //console.log('Managed academy: ', this.$store.state.selectedAcademy);
  },
  methods: {
    selectAcademy(newValue, force) {
      if (newValue != this.$store.state.selectedAcademy || force) {
        this.defaultSelected = newValue;
        this.$store.dispatch("setSelectedAcademy", newValue);
        this.$store.dispatch("setStripeAccountId", null);
        let managedAcademyId = null;
        for (const i of this.items) {
          if (i.value == newValue) {
            managedAcademyId = i.id;
            this.$store.dispatch("setManagedAcademy", i.id);
            this.$store.dispatch("setAcademyImage", i.image);
            localStorage.removeItem("tablet_token");
            break;
          }
        }
        if (managedAcademyId) {
          Api()
            .get("admins/managedacademy/" + managedAcademyId + "/manager/me")
            .then((response) => {
              const loggedUser = response.data.data;
              if (loggedUser) {
                console.log(loggedUser);
                this.$store.dispatch("setLanguage", loggedUser.language);
                this.$i18n.locale = loggedUser.language;
                this.darkTheme = loggedUser.darkMode;
                this.$vuetify.theme.dark = this.darkTheme;
                let theme = "light";
                if (this.darkTheme) theme = "dark";
                this.$store.dispatch("setTheme", theme);
                const baseUrl = Environment.get("VUE_APP_UI_HOST");
                window.location =
                  baseUrl + process.env.VUE_APP_PUBLIC_PATH + "secure/home";
              }
            });
        } else {
          const baseUrl = Environment.get("VUE_APP_UI_HOST");
          window.location =
            baseUrl + process.env.VUE_APP_PUBLIC_PATH + "secure/home";
        }
      }
    },
    getAdminAcademies() {
      //AdminService.academies();
      Api()
        .get("admins/academies")
        .then((response) => {
          let array = [];
          const data = response.data;
          if (data && data.length > 0) {
            if (data.length > 1) {
              //array.push({text:this.$t('message.all'),value:'all'});
            }
            for (const a of data) {
              if (a.academy) {
                if (a.default) {
                  this.defaultAcademy = a.academy._id;
                  this.defaultAcademyImage = a.academy.image;
                  this.defaultManagedAcademy = a._id;
                }
                array.push({
                  text: a.academy.name,
                  value: a.academy._id,
                  id: a._id,
                  image: a.academy.image,
                });
              } else {
                console.log(a);
              }
            }
            this.items = array;
            if (this.forceSelect) {
              if (array.length == 1) {
                const academyId = array[0].value;
                this.selectAcademy(academyId, true);
                return;
              }
            } else if (!this.$store.state.selectedAcademy) {
              //Update
              this.$store.dispatch("setSelectedAcademy", this.defaultAcademy);
              this.$store.dispatch(
                "setManagedAcademy",
                this.defaultManagedAcademy,
              );
              this.$store.dispatch("setAcademyImage", this.defaultAcademyImage);
              this.defaultSelected = this.defaultAcademy;
            } else {
              this.defaultSelected = this.$store.state.selectedAcademy;
            }
          }
        })
        .catch((e) => {
          console.log("Soemthing went wrong: ", e);
        });
    },
  },
};
</script>

<style scoped></style>
